import Icon from '../components/Icon.vue'

Icon.register({
  'hand-point-up': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M135.7 0c23.6 0 43.8 20.7 43.8 44.8v99.9c17-16.3 49.8-18.3 70.9 6.3 22.8-14.3 53-2.1 62.3 16.5 49.1-9 71.3 21.9 71.3 72.6 0 2.7-0.2 13.3-0.2 16 0.2 62-31.1 76.9-38.3 123.7-1.8 11.7-11.9 20.3-23.7 20.3h-171.5l0 0c-18.4 0-35.9-10.6-43.8-28.5-13-28.9-49-95.4-77.3-107.5-18.2-7.8-29.1-21.4-29.1-40 0-34.2 35.1-57.8 66.9-44.1 8.4 3.6 16.7 8.3 24.9 14.2v-149.2c0-23.5 20.5-44.8 43.8-44.8zM136 416h192c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-192c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zM304 444c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-point-up.js
// module id = 1431
// module chunks = 0